export const getHost = (win) => {
  return `${win.location.protocol}//${win.location.hostname}${(win.location.port ? `:${win.location.port}` : ':8080')}`;
};

export const uppercaseFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const isFunction = (fn) => {
  return fn && {}.toString.call(fn) === '[object Function]';
};
